import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { datadogRum } from '@datadog/browser-rum';

datadogRum.init({
  allowedTracingUrls: [
    process.env.REACT_APP_API_URL,
    process.env.REACT_APP_DASHBOARD_URL
  ].filter(Boolean) as string[],
  applicationId: process.env.REACT_APP_DATADOG_APP_ID || '',
  clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN || '',
  site: 'datadoghq.com',
  service: process.env.REACT_APP_DATADOG_SERVICE,
  env: process.env.REACT_APP_ENVIRONMENT,
  version: process.env.REACT_APP_DD_VERSION,
  sessionSampleRate: Number(process.env.REACT_APP_DATADOG_SAMPLE_RATE),
  sessionReplaySampleRate: Number(process.env.REACT_APP_DATADOG_REPLAY_SAMPLE_RATE),
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'mask-user-input'
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
